import { defineStore } from "pinia";
import { SessionAlertsApi } from "@simbelapp/order-sdk";
import { AlertScope, AlertTab } from "~/utils/enums/alerts.enums";
import type { IAlertsStore } from "~/utils/interfaces/alerts-interfaces";
import { useSDKApi } from "~/composables/api/useSDKApi";
import { MicroserviceEnum } from "~/utils/enums/common.enums";

export const useAlertsStore = defineStore("alertsStore", {
  state: (): IAlertsStore => ({
    showPanel: false,
    showArchiveAllModal: false,
    panelSource: null,
    selectedTab: AlertTab.ACTIVE,
    alerts: [],
    activeAlertsCount: 0,
    sessionAlertsCount: 0,
  }),
  getters: {
    hasActiveAlerts(): boolean {
      return this.activeAlertsCount > 0;
    },
    isGlobalPanel(): boolean {
      return this.showPanel && this.panelSource === AlertScope.GLOBAL;
    },
  },
  actions: {
    openPanel(source: AlertScope = AlertScope.GLOBAL) {
      this.selectedTab = AlertTab.ACTIVE;
      this.panelSource = source;
      this.showPanel = true;
    },
    closePanel() {
      this.showPanel = false;
      this.panelSource = null;
      this.alerts = [];
    },
    togglePanel(source: AlertScope = AlertScope.GLOBAL) {
      if (this.showPanel && this.panelSource === source) {
        this.closePanel();
      } else {
        this.openPanel(source);
      }
    },
    openArchiveAllModal() {
      this.showArchiveAllModal = true;
    },
    closeArchiveAllModal() {
      this.showArchiveAllModal = false;
    },
    async fetchActiveAlertsCount() {
      try {
        const api = await useSDKApi(MicroserviceEnum.ORDERS, SessionAlertsApi);
        const summary = await api.getSessionAlertsBellSummary();
        this.activeAlertsCount = summary.activeAlertsCount;
      } catch {
        this.activeAlertsCount = 0;
      }
    },
    async fetchSessionAlertsCount(sessionId: string) {
      try {
        const api = await useSDKApi(MicroserviceEnum.ORDERS, SessionAlertsApi);
        const summary = await api.getSessionAlertsBellSummaryBySession({
          sessionId,
        });
        this.sessionAlertsCount = summary.activeAlertsCount ?? 0;
      } catch {
        this.sessionAlertsCount = 0;
      }
    },
  },
});
